import { render } from "./AddTransfertMpostBoxPage.vue?vue&type=template&id=10644d9b&ts=true"
import script from "./AddTransfertMpostBoxPage.vue?vue&type=script&lang=ts"
export * from "./AddTransfertMpostBoxPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__